function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect } from "react";
import { useState } from "react";
import MdOutlineViewWeek from "@meronex/icons/mdc/MdcViewWeekOutline";
import MdOutlineGridView from "@meronex/icons/mdc/MdcViewGridOutline";
import { scrollToTargetAdjusted } from "../../../../utils/ui";
import { useMediaQuery, useTheme } from "@material-ui/core";
import ProjectFilter from "../../Components/ProjectFilter";
import GoSettings from "@meronex/icons/go/GoSettings";
import BsViewList from "@meronex/icons/bs/BsViewList";
import BsGrid from "@meronex/icons/bs/BsGrid";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Filter = function Filter(props) {
  var _config$deals$darkThe, _config$projects;
  var addFilterHandlerNew = props.addFilterHandlerNew,
    isMapView = props.isMapView,
    onMapClick = props.onMapClick,
    onGridClick = props.onGridClick,
    config = props.config,
    winnreNoAuth = props.winnreNoAuth,
    onResetFilters = props.onResetFilters;
  var theme = useTheme();
  var screenAboveLg = useMediaQuery(theme.breakpoints.up("lg"));
  var params = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");
  var userId;
  userId = params.get("userId");

  // preload enums if desired (optional)
  // useData({ winnreNoAuth });

  var mapButtonClick = function mapButtonClick() {
    return onMapClick === null || onMapClick === void 0 ? void 0 : onMapClick();
  };
  var gridButtonClick = function gridButtonClick() {
    return onGridClick === null || onGridClick === void 0 ? void 0 : onGridClick();
  };
  var clearAllFilters = function clearAllFilters() {
    onResetFilters === null || onResetFilters === void 0 || onResetFilters();
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openFilter = _useState2[0],
    setOpenFilter = _useState2[1];
  var handleOpenFilter = function handleOpenFilter() {
    setOpenFilter(true);
  };
  var handleCloseFilter = function handleCloseFilter() {
    setOpenFilter(false);
  };
  var handleResetFilter = function handleResetFilter() {
    clearAllFilters();
    handleCloseFilter();
  };
  var applyFilter = function applyFilter(cityList, priceRange, typeList) {
    // console.log(cityList, priceRange, typeList);
    addFilterHandlerNew(priceRange, "BUDGET");
    addFilterHandlerNew(cityList, "LOCATION");
    addFilterHandlerNew(typeList, "APARTMENT_TYPE");
    handleCloseFilter();
  };
  // console.log(isMapView);
  return /*#__PURE__*/_jsx("div", {
    id: "projectsContainer",
    className: "block ",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("div", {
        className: "bg-transparent",
        children: /*#__PURE__*/_jsx("div", {
          className: "container mx-auto ",
          children: /*#__PURE__*/_jsx("div", {
            className: "flex justify-end",
            children: /*#__PURE__*/_jsxs("div", {
              className: "flex lg:gap-x-4 z-10",
              children: [openFilter && /*#__PURE__*/_jsx(ProjectFilter, {
                isOpenFilter: openFilter,
                onResetFilter: handleResetFilter,
                applyFilter: applyFilter,
                onCloseFilter: handleCloseFilter,
                winnreNoAuth: winnreNoAuth,
                config: config
              }), /*#__PURE__*/_jsx("div", {
                className: "lg:pr-4 lg:border-r",
                children: /*#__PURE__*/_jsxs("button", {
                  type: "button",
                  className: screenAboveLg ? "flex items-center ".concat(config !== null && config !== void 0 && config.darkMode ? (config === null || config === void 0 || (_config$deals$darkThe = config.deals.darkTheme) === null || _config$deals$darkThe === void 0 ? void 0 : _config$deals$darkThe.text) || "text-white border-primary" : "text-gray-700", " px-4 py-3 border-[1.9px] font-medium rounded-lg  ").concat(config === null || config === void 0 || (_config$projects = config.projects) === null || _config$projects === void 0 || (_config$projects = _config$projects.moduleConfig) === null || _config$projects === void 0 ? void 0 : _config$projects.fontTitle) : "",
                  onClick: function onClick() {
                    return setOpenFilter(!openFilter);
                  },
                  children: [/*#__PURE__*/_jsx(GoSettings, {
                    className: "w-5 h-5 lg:mr-2 "
                  }), screenAboveLg ? "Filter" : ""]
                })
              }), screenAboveLg && /*#__PURE__*/_jsx("button", {
                className: "px-3.5 py-2 rounded-lg ".concat(isMapView ? "text-white" : "text-black border-[1.9px]"),
                style: {
                  backgroundColor: isMapView ? config === null || config === void 0 ? void 0 : config.primaryColor : "#FFFFFF"
                },
                onClick: mapButtonClick,
                children: /*#__PURE__*/_jsx(BsViewList, {
                  className: " h-6 w-6"
                })
              }), console.log(config === null || config === void 0 ? void 0 : config.primaryColor), screenAboveLg && /*#__PURE__*/_jsx("button", {
                className: "px-3 py-2 rounded-lg ".concat(isMapView ? "text-black border-[1.9px]" : "text-white", " "),
                style: {
                  backgroundColor: isMapView ? "#FFFFFF" : config === null || config === void 0 ? void 0 : config.primaryColor
                },
                onClick: gridButtonClick,
                children: /*#__PURE__*/_jsx(BsGrid, {
                  className: " h-6 w-6"
                })
              })]
            })
          })
        })
      })
    })
  });
};
export default Filter;